import { useState } from 'react';
import { DocumentHead } from '../components/DocumentHead';
import { Hero } from '../components/Hero';
import { TrustStrip } from '../components/TrustStrip';
import { ShopOnlineBand } from '../components/ShopOnlineBand';
import { Pathways } from '../components/Pathways';
import { WhyPegasus } from '../components/WhyPegasus';
import { HotTubs } from '../components/HotTubs';
import { BackyardLiving } from '../components/BackyardLiving';
import { ServiceCare } from '../components/ServiceCare';
import { SpecialsVisit } from '../components/SpecialsVisit';
import { SpecialsTextDialog } from '../components/SpecialsTextDialog';
export function Home() {
  const [textDialogOpen, setTextDialogOpen] = useState(false);
  return <>
      <DocumentHead data-id="element-1446" data-mp="2dja0ooytesl9" />
      <main data-id="element-1447" data-mp="2dfm5zmhmw04y">
        <Hero data-id="element-1448" data-mp="3kvaewubpapz8" />
        <TrustStrip data-id="element-1449" data-mp="3kvk3qel0er3c" />
        <ShopOnlineBand data-id="element-1450" data-mp="3ku8qlo5oc6zk" />
        <Pathways data-id="element-1451" data-mp="3kuqtv4qr7lgz" />
        <WhyPegasus data-id="element-1452" data-mp="3kxd5pgkogn50" />
        <HotTubs data-id="element-1453" data-mp="3owlvybgie2vt" />
        <BackyardLiving data-id="element-1454" data-mp="3ow437ot226sn" />
        <ServiceCare data-id="element-1455" data-mp="3ovkmucj1zqgq" />
        <SpecialsVisit onOpenTextDialog={() => setTextDialogOpen(true)} data-id="element-1456" data-mp="3oyyo1hfzdtml" />
      </main>
      <SpecialsTextDialog open={textDialogOpen} onClose={() => setTextDialogOpen(false)} data-id="element-1457" data-mp="30w9nf4asqr08" />
    </>;
}